import React, { FC } from 'react'
import ReactTooltip from 'react-tooltip'
import { TooltipProps } from 'react-tooltip'
import styled from 'styled-components'

import { getProjectName } from '../../lib/get-project-name'
import { createMediaStyles } from '../../lib/styled-helpers'

export const Tooltip: FC<TooltipProps> = (props) => {
  return (
    <ReactTooltipStyled
      className={'customTooltip'}
      effect={'solid'}
      place="top"
      type="light"
      backgroundColor={'white'}
      {...props}
    />
  )
}

export const ReactTooltipStyled = styled(ReactTooltip)`
  &.customTooltip {
    max-width: ${({ theme }) => theme.spacing[80]};
    min-width: 264px;
    text-align: center;

    padding: ${({ theme }) => `${theme.spacing[3]} ${theme.spacing[5]}`};
    cursor: pointer;
    box-shadow: 0 0.2rem 0.8rem 0 rgb(0, 0, 0, 20%);

    pointer-events: auto;

    ${({ theme }) => theme.textStyles.p3};

    ${() =>
      createMediaStyles(() => ({
        phone: ` width: 264px; max-width: 264px; right: 30px;`,
        tablet: 'min-width: 264px; right: 0px'
      }))}

    border-radius: ${() => getProjectName() === 'avito' && '8px'};

    &.show {
      opacity: 1 !important;
    }
  }
`
